export default {
    // inviteStatictis: '/gateway/huilianOperation/invitecs/inviteStatictis', //拉新奖励统计
    // selectInviteList: '/gateway/huilianOperation/invitecs/selectInviteList', //拉新列表查询
    myChargeCarrierDetail:
        "/gateway/huilianCharge/chargeCarriercs/myChargeCarrierDetail", //我的充电运营商信息
    selectChargeCarrierInviteIncomeByCondition:
        "/gateway/huilianCharge/chargeCarrierInviteIncomecs/selectChargeCarrierInviteIncomeByCondition", //充电运营商返利列表
};



// WEBPACK FOOTER //
// ./src/yysChargingOperator/detail/api.js